export default "__VITE_ASSET__fabcd707__"